import logo1 from './1.svg';
import logo2 from './2.svg';
import logo3 from './3.svg';
export default function AboutRouteBilling() {
  const features = [
    {
      title: 'Order Pick From Store',
      img: logo1, // replace with your image
    },
    {
      title: 'Delivery to Doorstep',
      img: logo2,
    },
    {
      title: 'Instant Bill Generate',
      img: logo3,
    },
  ];

  return (
    <section className="bg-white container px-5 mx-auto pt-10">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            About <span className="text-orange-500">routeBilling</span>
          </h2>
          <p className="text-gray-600 mb-6">
            Built for Your Industry. Designed for Your Success.
          </p>
          <p className="text-gray-600 leading-relaxed">
            routeBilling is purpose-built for businesses that rely on efficient
            route management—whether you’re in delivery, distribution, or field
            services. Our platform provides powerful, easy-to-use tools to
            streamline your daily operations, reduce errors, improve cash flow,
            and drive sustainable growth.
          </p>
        </div>

        {/* Right Features */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {features.map((f, idx) => (
            <div
              key={idx}
              style={{
                marginTop: idx === 1 && window.innerWidth > 640 ? 40 : 0,
              }}
              className="bg-white h-fit shadow-2xl rounded-2xl p-6 flex flex-col items-center text-center hover:shadow-lg transition"
            >
              <img
                src={f.img}
                alt={f.title}
                className="w-20 h-20  object-contain"
              />
              <h3 className="font-semibold text-gray-800">{f.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
